// extracted by mini-css-extract-plugin
export default {"wrapper":"LampDinners2024_wrapper__+y4mX"};